import React, { useState } from 'react';
import { Modal, Button, Container, Table } from 'react-bootstrap';
import AddScheduleComp from '../../../../pages/CoachingRequestForm/AddSchedule/AddScheduleComp';

const Four8HourBookingModal = ({ show, setShow, getRequestList, itemId, hour, selectedRequest }) => {
    let formResetObj = {
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        url: "",
        // timeZone: "",
        weeklyDays: [],
        dayOfMonth: "",
        firstSecondThird: "",
        dayWeekdayWeekend: "",
        monthNo: "",
    };
    const [formData, setFormData] = useState(formResetObj);
    return (
        <Modal
            show={show}
            onHide={() => { setShow(false) }}
            backdrop="static"
            keyboard={false}
            className="custom-modal"
            size="md"
            centered
        >
            <Modal.Header closeButton className="border-0"></Modal.Header>
            <Modal.Body >

                {<>
                    <Container>
                        {!selectedRequest?.is_coach && <h3>Request Detail</h3>}
                        {!selectedRequest?.is_coach && <Table striped bordered hover>
                            <tbody>
                                <tr>
                                    <th>Preferred Date:</th>
                                    <td>{selectedRequest.preferredDate}</td>
                                </tr>
                                <tr>
                                    <th>Preferred Time:</th>
                                    <td>{selectedRequest.preferred_time}</td>
                                </tr>
                                <tr>
                                    <th>Request From:</th>
                                    <td>{selectedRequest.request_from_name}</td>
                                </tr>
                                <tr>
                                    <th>Requested Hour:</th>
                                    <td>{selectedRequest.hour}</td>
                                </tr>
                                <tr>
                                    <th>Remark:</th>
                                    <td>{selectedRequest.remark}</td>
                                </tr>
                            </tbody>
                        </Table>}

                        <AddScheduleComp
                            showAdd={show}
                            setShowAdd={setShow}
                            formData={formData}
                            setFormData={setFormData}
                            formResetObj={formResetObj}
                            getslots={getRequestList}
                            from={"4hour"}
                            itemId={itemId}
                            hour={hour}
                            request_type={selectedRequest?.request_type}
                            isCoach = {selectedRequest?.is_coach} />

                    </Container>
                </>
                }
            </Modal.Body>
        </Modal>
    );
};

export default Four8HourBookingModal;